// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import { dispatch } from '../index';

import { getCallHistory } from 'api/patient';
import * as alertSnackbar from 'utils/snackbar-wrapper';
import { toCalendarDate } from 'utils/calendarDate';

// ----------------------------------------------------------------------

const initialState = {
    callHistoryList: {
        error: false,
        loaded: false,
        calls: [],
        metadata: {
            totalCount: 0,
            totalDurationSeconds: 0,
            pageSize: 20
        }
    }
};

const slice = createSlice({
    name: 'callHistory',
    initialState,
    reducers: {
        setCallHistoryListLoading(state) {
            state.callHistoryList.loaded = false;
        },
        setCallHistoryList(state, action) {
            state.callHistoryList.error = false;
            state.callHistoryList.loaded = true;
            state.callHistoryList.calls = action.payload.calls;
            state.callHistoryList.metadata = action.payload.metadata;
        },
        setCallHistoryListError(state) {
            state.callHistoryList.error = true;
            state.callHistoryList.loaded = true;
        },
        resetState(state) {
            state.callHistoryList = initialState.callHistoryList;
        }
    }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function resetState() {
    dispatch(slice.actions.resetState());
}

/*
dateRange is a [from, to] tuple of Date objects (or null when not selected).
Sent to the backend as inclusive calendar days, matching the previous care
timeline filter; the server resolves them in the app zone.
*/
export function getCallHistoryList(patientId, page, dateRange) {
    return async () => {
        try {
            dispatch(slice.actions.setCallHistoryListLoading());
            const from = toCalendarDate(dateRange?.[0]) ?? undefined;
            const to = toCalendarDate(dateRange?.[1]) ?? undefined;
            const response = await getCallHistory(patientId, page, from, to);
            dispatch(slice.actions.setCallHistoryList(response.data));
        } catch (error) {
            dispatch(alertSnackbar.error('Failed to fetch call history'));
            dispatch(slice.actions.setCallHistoryListError());
        }
    };
}
